import { Link } from 'react-router-dom';
import { Footer, TermsHero } from '../components';
import './refundCancellationPolicy.css';

const RefundCancellationPolicy = () => {
  return (
    <div className="refund-cancellation-page">
      <TermsHero
        title="Refund & Cancellation Policy"
        subtitle="How subscriptions may be cancelled and when refunds apply"
      />
      <div className="legal-content-section">
        <div className="legal-content-container container">
          <div className="legal-content-text">
            This Cancellation &amp; Refund Policy outlines the terms under which subscriptions to{' '}
            <span className="text-highlight">flowdo</span>, a platform developed and managed by Innate Technologies L.L.C-FZ (Dubai, UAE), may be cancelled and refunded. By subscribing to flowdo, you agree to this policy.
            <br />
            <strong>1. Subscription Overview</strong>
            flowdo offers flexible subscription plans that allow customers to choose and pay for specific modules based on:
            <ol>
              <li>• Number of users</li>
              <li>• Storage requirements</li>
              <li>• Selected functionalities</li>
            </ol>
            Customers may opt for either:
            <ol>
              <li>• Monthly Billing, or</li>
              <li>• Yearly Billing (discounted pricing)</li>
            </ol>
            All prices are displayed in USD, and billing will appear under Innate Technologies L.L.C-FZ.
            <br />
            <strong>2. Cancellation Policy</strong>
            <ol>
              <li>• Customers may cancel their subscription at any time through their account settings or by contacting support.</li>
              <li>• Upon cancellation:</li>
              <ol>
                <li>No further charges will be applied.</li>
                <li>Access to paid features will continue until the end of the current billing cycle.</li>
              </ol>
              <li>• No additional cancellation fees will be charged.</li>
            </ol>
            <strong>3. Monthly Subscription – Refund Policy</strong>
            <ol>
              <li>• No refunds will be provided for monthly subscriptions once the payment has been successfully processed.</li>
              <li>• This applies regardless of usage or non-usage of the platform.</li>
            </ol>
            <strong>Exception</strong>
            Refunds or service adjustments may be considered only if:
            <ol>
              <li>• The Flowdo platform is unavailable or non-functional for an extended period due to system issues.</li>
            </ol>
            In such cases:
            <ol>
              <li>• Subscription periods may be extended proportionately to compensate for downtime, instead of monetary refunds.</li>
            </ol>
            <strong>4. Yearly Subscription – Refund Policy</strong>
            Yearly subscriptions are offered at discounted rates, and therefore refunds are subject to the following conditions:
            <br />
            If a refund request is approved:
            <ol>
              <li>• The usage period will be calculated from the subscription start date.</li>
              <li>• A minimum penalty equivalent to 3 months of subscription fees will be applied.</li>
              <li>• The remaining eligible amount (if any) will be refunded after deduction.</li>
              <li>• All refund requests for yearly plans are subject to review and approval by Flowdo.</li>
            </ol>
            <strong>5. General Refund Conditions</strong>
            <ol>
              <li>• Once a credit card has been charged, refunds are generally not permitted except as stated in this policy.</li>
              <li>• Refunds, if applicable, will be processed only to the original payment method (same credit card) used at the time of purchase.</li>
              <li>• Processing time for refunds may vary depending on the payment provider and issuing bank.</li>
            </ol>
            <strong>6. Service Downtime</strong>
            In the event of unexpected system downtime or inaccessibility lasting multiple days:
            <ol>
              <li>• flowdo will make reasonable efforts to restore services promptly.</li>
              <li>• Affected users may receive a subscription extension equivalent to the downtime period.</li>
            </ol>
            <strong>7. Changes to This Policy</strong>
            flowdo reserves the right to modify this Cancellation &amp; Refund Policy at any time. Updates will be posted on the website with the revised &quot;Last Updated&quot; date. Continued use of the platform constitutes acceptance of the updated policy.
            <br />
            <strong>8. Contact Us</strong>
            For any questions regarding cancellations or refunds, please contact{' '}
            <Link to="mailto:info@flowdo.biz">info@flowdo.biz</Link>
            <br />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RefundCancellationPolicy;
